module.exports = "<div *ngIf=\"user\">\n  <h2 class=\"page-header\">{{user.name}}</h2>\n  <ul class=\"list-group\">\n    <li class=\"list-group-item\">Username: {{user.username}}</li>\n    <li class=\"list-group-item\">Email: {{user.email}}</li>\n  </ul>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/profile/profile.component.html
// module id = ./src/app/components/profile/profile.component.html
// module chunks = main